import React from 'react'

function Shimmer() {
  return (
    
      <div className="col col3">
        <div className="cat-wrap">
        <div className="cat-img shimmerBG" style={{height:"757px"}}></div>      
        <div className='shimmerBG' style={{height:"75px"}}></div>
        </div>
    </div>
    
  )
}

export default Shimmer
